import { render, staticRenderFns } from "./OnlineCoursePricingForm.vue?vue&type=template&id=9f8067fe&scoped=true"
import script from "./OnlineCoursePricingForm.vue?vue&type=script&lang=js"
export * from "./OnlineCoursePricingForm.vue?vue&type=script&lang=js"
import style0 from "./OnlineCoursePricingForm.vue?vue&type=style&index=0&id=9f8067fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8067fe",
  null
  
)

export default component.exports